import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { publicApi } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { Field, Spinner, ErrorNote } from '../components/ui';

const MIN = 8;

/** Shared by the invite and reset screens — both set a password from a token. */
export function SetPasswordForm({ submitLabel, onSubmit, heading, intro }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function handle(e) {
    e.preventDefault();
    if (password.length < MIN) return setError(`Use at least ${MIN} characters.`);
    if (password !== confirm) return setError('The two passwords don’t match.');
    setBusy(true); setError('');
    try { await onSubmit(password); }
    catch (err) { setError(err.message || 'Something went wrong'); }
    finally { setBusy(false); }
  }

  return (
    <main className="login-wrap">
      <img className="logo" src="/logo.png" alt="" />
      <h1>{heading}</h1>
      {intro ? <p className="sb">{intro}</p> : null}
      <form className="col" style={{ gap: 'var(--s-3)' }} onSubmit={handle}>
        <Field label="New password" id="pw" hint={`At least ${MIN} characters`}>
          <input id="pw" className="fi" type="password" autoComplete="new-password" required
            value={password} onChange={e => setPassword(e.target.value)} />
        </Field>
        <Field label="Confirm password" id="pw2" error={error}>
          <input id="pw2" className="fi" type="password" autoComplete="new-password" required
            value={confirm} onChange={e => setConfirm(e.target.value)} />
        </Field>
        <button className="btn pri" type="submit" disabled={busy}>{busy ? 'Saving…' : submitLabel}</button>
      </form>
    </main>
  );
}

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { data, error, loading } = useAsync(() => publicApi.get('/users/invite/' + token), [token]);

  if (loading) return <Spinner label="Checking invite" />;
  if (error) {
    return (
      <main className="login-wrap">
        <img className="logo" src="/logo.png" alt="" />
        <h1>Invite not valid</h1>
        <ErrorNote>{error}</ErrorNote>
        <p className="sb">Ask the owner to send you a fresh invite.</p>
      </main>
    );
  }

  return (
    <SetPasswordForm
      heading={`Welcome, ${(data?.name || '').split(' ')[0] || 'there'}`}
      intro={`Choose a password for ${data?.email}. You'll use it to sign in from your phone.`}
      submitLabel="Set password & continue"
      onSubmit={async (password) => {
        await publicApi.post('/users/accept-invite', { token, password });
        navigate('/login', { replace: true });
      }}
    />
  );
}
